// extracted by mini-css-extract-plugin
export default {"container":"TagDrawer_container__EG4Ea"};